export interface ErrorType {
  color: string;
  label: string;
  type?: string;
  fields?: string[];
}

export interface ErrorTypes {
  [key: string]: ErrorType;
}

export enum UploadType {
  CREATION = 'Créer élèves',
  MISE_A_JOUR = 'Mettre à jour élèves',
  INSCRIPTION = 'Inscription élèves',
  REINSCRIPTION = 'Réinscription élèves',
}
export interface Operation {
  id?: string;
  label: string;
  templateUrl: string;
  instructions: string;
  schema: string[];
  description: string;
}

export interface ValidationError {
  line: number;
  type: keyof ErrorTypes;
  message: string;
  fields: string[];
}

export interface ErrorMap {
  [key: number]: ErrorType[];
}

export interface ParsedData {
  headers: string[];
  data: any[];
  totalRows: number;
  findIndex?: (callback: (item: any) => boolean) => number;
  slice?: (start?: number, end?: number) => any[];
  length?: number;
}
